"use client";

const EVENT = "dux-hub:chat";

type ChatCommand = "open" | "close" | "toggle";

export function openChat(trigger?: string) {
  emit("open", trigger);
}

export function closeChat() {
  emit("close");
}

export function toggleChat(trigger?: string) {
  emit("toggle", trigger);
}

export function onChatCommand(
  handler: (cmd: ChatCommand, trigger?: string) => void
) {
  if (typeof window === "undefined") return () => {};
  const listener = (e: Event) => {
    const detail = (e as CustomEvent).detail as {
      cmd: ChatCommand;
      trigger?: string;
    };
    handler(detail.cmd, detail.trigger);
  };
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}

function emit(cmd: ChatCommand, trigger?: string) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { cmd, trigger } }));
}
